import { render, staticRenderFns } from "./Armor.vue?vue&type=template&id=065c7da0&scoped=true&"
import script from "./Armor.vue?vue&type=script&lang=js&"
export * from "./Armor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c7da0",
  null
  
)

export default component.exports